import { useQuery } from 'react-query'

import { transactionLogsService } from 'src/services/transaction-logs.service'
import { removeDefaultParams } from 'src/common/utils'
import { QUERY_KEYS } from 'src/constants'
import { IFilter } from 'src/components/filter/types/filter.types'

export const initialTxLogsFilterValues = {
  query: '',
  type: ['all'],
}

export const useTransactionLogs = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.TRANSACTION_LOGS, filter],
    () =>
      transactionLogsService.getTransactionLogs(
        removeDefaultParams({ ...filter }, initialTxLogsFilterValues),
      ),
    { keepPreviousData: true },
  )
}
